import { render, staticRenderFns } from "./Shelterlist.vue?vue&type=template&id=78bd7512&"
import script from "./Shelterlist.vue?vue&type=script&lang=js&"
export * from "./Shelterlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports